"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bindTombacStaticTool = bindTombacStaticTool;
exports.bindTombacTool = bindTombacTool;
exports.pxToUnit = pxToUnit;
exports.resolveTheme = resolveTheme;
exports.tombacThemeColors = void 0;
var _defaultTheme = require("../../themes/defaultTheme");
const tombacThemeColors = exports.tombacThemeColors = ["accent", "alert", "neutral", "primary", "success", "danger"];
function bindTombacTool(tool, theme) {
  return function () {
    return tool(...arguments)({
      theme
    });
  };
}
function bindTombacStaticTool(tool, theme) {
  return tool({
    theme
  });
}
function pxToUnit(px, unit) {
  return px === 0 ? "0" : unit === "rem" ? `${px / 16}rem` : `${px}px`;
}
function resolveTheme(theme) {
  return {
    ..._defaultTheme.defaultTheme,
    ...theme
  };
}
//# sourceMappingURL=tombacCommons.js.map